import { defineStore } from 'pinia'
import { ref, computed } from 'vue'
import { useRouter } from 'vue-router'
import { api } from '@/libs/mande'
import { useUserStore } from '@/stores/user'
import { jwtDecode, type JwtPayload } from 'jwt-decode'
import { useMessagesStore } from './messages'

interface Session {
  user_id: number
  nickname: string
  role: string
  token: string
}

interface JWTSession extends JwtPayload {
  iat: number // issued at
  iss: string // issuer
  sub: string // subject aka subscriber aka user_id
  n: string // name
  r: string // role
}

export const useAuthStore = defineStore('auth', () => {
  const session = ref<Session | null>(null)

  if (document.cookie.length > 0) {
    const cookie = document.cookie.split('; ').find((row) => row.startsWith('session='))
    if (cookie) {
      const jwt = cookie.split('=')[1]
      const decoded = jwtDecode(jwt) as JWTSession
      // console.info(decoded)
      // session.value = JSON.parse(cookie.split('=')[1]) as Session | null
      session.value = {
        user_id: parseInt(decoded.sub),
        nickname: decoded.n,
        role: decoded.r,
        token: jwt
      } as Session
    }
  }

  // onBeforeMount(() => {
  //   if (session.value == null && document.cookie.length > 0) {
  //     const cookie = document.cookie.split('; ').find((row) => row.startsWith('session='))
  //     if (cookie) {
  //       const jwt = cookie.split('=')[1]
  //       const decoded = jwtDecode(jwt) as JWTSession
  //       // console.info(decoded)
  //       // session.value = JSON.parse(cookie.split('=')[1]) as Session | null
  //       session.value = {
  //         user_id: parseInt(decoded.sub),
  //         nickname: decoded.n,
  //         role: decoded.r,
  //         token: jwt
  //       } as Session
  //     }
  //   }
  // })

  const router = useRouter()

  const login = async (phone: string) => {
    await api.post('/authenticate/' + phone, { channel: 'sms' })
    router.push('/verify?phone=' + phone)
  }

  const verify = async (phone: string, code: string) => {
    const resp = await api.post('/authenticate/' + phone + '/' + code, {})
    session.value = resp as Session
    if (session.value !== undefined) {
      const expires = new Date()
      expires.setTime(expires.getTime() + 7 * 24 * 60 * 60 * 1000) // 1 week in milliseconds
      document.cookie = `session=${session.value.token}; path=/; expires=${expires.toUTCString()}`
    }

    const userStore = useUserStore()
    if (await userStore.IsAdmin()) {
      router.push('/admin')
    } else if (await userStore.IsClinician()) {
      router.push('/clinician')
    } else {
      router.push('/workbook')
    }
  }

  const sudo = async (role: string) => {
    const resp = await api.post('/sudo', { role })
    session.value = resp as Session
    console.log('new session', session.value)
    if (session.value !== undefined) {
      const expires = new Date()
      expires.setTime(expires.getTime() + 7 * 24 * 60 * 60 * 1000) // 1 week in milliseconds
      document.cookie = `session=${session.value.token}; path=/; expires=${expires.toUTCString()}`
      // const jwt = session.value.token
      // const decoded = jwtDecode(jwt) as JWTSession
      // session.value = {
      //   user_id: parseInt(decoded.sub),
      //   nickname: decoded.n,
      //   role: decoded.r,
      //   token: jwt
      // } as Session

      const userStore = useUserStore()
      userStore.setCurrentUser(null)
      userStore.getCurrentUser()

      if (await userStore.IsAdmin()) {
        router.push('/admin')
      } else if (await userStore.IsClinician()) {
        router.push('/clinician')
      } else {
        router.push('/workbook')
      }
    }
  }

  const logout = async () => {
    session.value = null
    localStorage.removeItem('session')
    localStorage.removeItem('user')
    document.cookie = 'session=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT'
    // setAuthToken('')
    useMessagesStore().resetMessagesState()
    router.push('/login')
  }

  const isAuthenticated = computed(() => session.value !== null)

  const getUserID = computed(() => {
    if (session.value === null) return null
    return session.value.user_id
  })

  const handleAPIError = (error: any) => {
    if (error.response.status === 401) {
      console.info('Unauthorized, logging out')
      logout()
    } else {
      console.error(error)
    }
  }

  const waitlist = (phone: string | undefined, note: string | undefined) => {
    api.post('/waitlist', { phone, note })
  }

  return {
    session,
    waitlist,
    login,
    sudo,
    verify,
    logout,
    isAuthenticated,
    getUserID,
    handleAPIError
  }
})
